import { useEffect, useState } from "react"
import { PromotionalTilePLP } from "@kohler-dsm-library/kohler-core"
import { getPromoBannerProps } from "@/components/PromoBanner/v3/PromoBannerHelper"
import PropTypes from "prop-types"

const PromoBannerV2 = ({ xfLink, promoIndex, desktopPromo }) => {
  const [promoData, setPromoData] = useState(null)
  useEffect(() => {
    const loadPromo = async () => {
      const data = await getPromoBannerProps({
        xfLink,
        promoIndex,
        desktopPromo,
      })
      setPromoData(data)
    }
    loadPromo()
  }, [xfLink])

  // Optional loading state
  if (!promoData) return null

  return <PromotionalTilePLP {...promoData} />
}

export default PromoBannerV2

PromoBannerV2.propTypes = {
  xfLink: PropTypes.string,
  promoIndex: PropTypes.number,
  desktopPromo: PropTypes.string,
}
